import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-7 w-7" }) => (
  <img src="/calibrunway-mark.png" alt="" aria-hidden="true" className={`${className} object-contain select-none`} draggable={false} />
);

export const Logo = ({ className = "", testid = "brand-logo" }) => (
  <Link to="/" data-testid={testid} className={`flex items-center gap-2 ${className}`} aria-label="CalibRunway home">
    <LogoMark />
    <span className="font-display text-lg font-semibold tracking-tight">Calib<span className="text-[#00FF9D]">Runway</span></span>
  </Link>
);
